import React, { useEffect } from 'react';
import './styles/Classes.css';

const Classes = () => {
  const classData = [
    {
      icon: '🌐',
      name: 'Online Classes',
      // price: '₹2,000/month',
      features: ['Live instruction', 'Recorded sessions', 'Personal feedback']
    },
    {
      icon: '🏛️',
      name: 'In-Person Sessions',
      // price: '₹3,500/month',
      features: ['Traditional setting', 'Group energy', 'Hands-on corrections']
    },
    {
      icon: '✨',
      name: 'Drop-in Trials',
      // price: '₹500/session',
      features: ['Single session', 'No commitment', 'Basic introduction']
    },
    {
      icon: '🎭',
      name: 'Full-term Training',
      // price: '₹15,000/term',
      features: ['Complete curriculum', 'Theory & practice', 'Performance opportunities']
    }
  ];

  const levelData = [
    {
      name: 'Beginners',
      content: 'Basic adavus, simple jathis, and fundamental postures',
      // duration: '6-12 months'
    },
    {
      name: 'Intermediate',
      content: 'Complex choreography, abhinaya basics, and rhythm mastery',
      // duration: '1-2 years'
    },
    {
      name: 'Advanced',
      content: 'Full items, sophisticated abhinaya, and performance readiness',
      // duration: '2+ years'
    }
  ];

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    const animateElements = document.querySelectorAll('.class-card, .level-card');
    animateElements.forEach(el => {
      el.classList.add('fade-in');
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="classes" className="classes">
      <div className="container">
        <h2 className="section-title">Our Classes</h2>
        <p className="section-subtitle">Choose your path in the sacred art of Bharatanatyam</p>

        <div className="classes-grid">
          {classData.map((classItem, index) => (
            <div key={index} className="class-card">
              <div className="class-icon">{classItem.icon}</div>
              <h3>{classItem.name}</h3>
              <div className="class-price">{classItem.price}</div>
              <ul className="class-features">
                {classItem.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Learning Levels */}
        <div className="learning-levels">
          <h3>Learning Levels</h3>
          <div className="levels-grid">
            {levelData.map((level, index) => (
              <div key={index} className="level-card">
                <h4>{level.name}</h4>
                <p className="level-content">{level.content}</p>
                <p className="level-duration">{level.duration}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Classes;